<template>
  <div class="page-content" style="margin-top: 20px">
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span" style="margin-left:6px">编辑会员权益</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div form-submit-page">
        <el-form :inline="false" :model="formInline" class="box-content-form" label-width="100px">
          <el-form-item label="权益名称:">
            <el-input v-model="formInline.in_title" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="权益类型:">
            <el-select v-model="formInline.in_type" placeholder="请选择权益类型">
              <el-option
                v-for="item in interestOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="链接地址" v-if="formInline.in_type === 1 || formInline.in_type === ''">
            <el-input v-model="formInline.in_url" placeholder="" ></el-input>
          </el-form-item>
          <el-form-item label="礼物名称:" v-if="formInline.in_type === 2">
            <el-input v-model="formInline.in_gift_name" placeholder="" ></el-input>
          </el-form-item>
          <el-form-item label="礼物编号:" v-if="formInline.in_type === 2">
            <el-input v-model="formInline.pro_code" placeholder="礼物编号是外部商品编号，比如管易的"></el-input>
          </el-form-item>
          <el-form-item label="权益分类:">
            <el-select v-model="formInline.in_classify" placeholder="请选择权益分类">
              <el-option
                v-for="item in classifyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会员日:" v-if="formInline.in_classify === '' || formInline.in_classify === 2">
            <el-select v-model="formInline.in_member_day" placeholder="请选择会员日">
              <el-option
                v-for="item in memberDayOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间:" v-if="formInline.in_classify === '' || formInline.in_classify === 1">
            <el-date-picker style="width:193px;"
              v-model="formInline.in_start"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:" v-if="formInline.in_classify === '' || formInline.in_classify === 1">
            <el-date-picker style="width:193px;"
              v-model="formInline.in_end"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="权益适用等级:" class="interest-type">
            <el-select v-model="interestFitValue" multiple placeholder="请选择权益适用等级">
              <el-option
                v-for="item in interestFitOptions"
                :key="item.id"
                :label="item.level_title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权益图标:">
            <!--<el-upload-->
                      <!--class="interest-uploader"-->
                      <!--name="file_upload"-->
                      <!--:action="uploadURL"-->
                      <!--:show-file-list="false"-->
                      <!--:on-success="handleFilesSuccess"-->
                      <!--:before-upload="beforeAvatarUpload">-->
                  <!--<div v-if="formInline.in_logo"  class="opacity-div1">-->
                      <!--<img :src="formInline.in_logo" class="interest-image">-->
                      <!--<div class="back-div">点击更换</div>-->
                  <!--</div>-->
                  <!--<div slot="tip" style="line-height:15px;color:#606266;">必填！建议尺寸340*340</div>-->
                  <!--<img v-if="formInline.in_logo === ''"  src="../../assets/images/Group.png" class="default-images">-->
              <!--</el-upload>-->
            <el-upload
                      class="avatar-uploader"
                      name="file_upload"
                      :action="uploadURL"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload">
                  <div v-if="formInline.in_logo" class="upload_img">
                      <img v-if="formInline.in_logo" :src="formInline.in_logo" class="avatar">
                      <div class="modify_img">点击修改</div>
                  </div>
                  <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                  <img v-else src="../../assets/images/Group.png" class="default-acivity">
                  <div slot="tip" style="line-height:20px;color:#606266;">必填！建议尺寸340*340</div>
              </el-upload>
          </el-form-item>
          <el-form-item label="未点亮图标:">
            <el-upload
                      class="avatar-uploader"
                      name="file_upload"
                      :action="uploadURL"
                      :show-file-list="false"
                      :on-success="handleFilesSuccess"
                      :before-upload="beforeAvatarUpload">
                  <div v-if="formInline.in_fit_logo" class="upload_img">
                      <img v-if="formInline.in_fit_logo" :src="formInline.in_fit_logo" class="avatar">
                      <div class="modify_img">点击修改</div>
                  </div>
                  <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                  <img v-else src="../../assets/images/Group.png" class="default-acivity">
                  <div slot="tip" style="line-height:20px;color:#606266;">必填！建议尺寸340*340</div>
              </el-upload>
          </el-form-item>
          <el-form-item label="内容:">
            <el-input v-model="formInline.in_content" placeholder="" type="textarea" :rows="4"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button class="second-page-btn" style="float: left;margin-top: 70px;" type="primary" @click="saveMemberInterestAction">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>
<script>
import { API_HOST } from '@/api/local'
import { getMemberInterestDetails, getMemberLevelList, modifyMemberInterestDetails } from '@/api/customer.js'
export default {
  name: 'importData',
  data () {
    return {
      formInline: {
        in_classify: '',
        in_grade_list: '',
        in_title: '',
        in_type: '',
        in_url: '',
        in_gift_name: '',
        in_member_day: '',
        in_start: '',
        in_end: '',
        in_logo: '',
        in_fit_logo: '',
        in_content: '',
        pro_code: ''
      },
      interestFitValue: [],
      interestFitOptions: [],
      interestOptions: [
        {
          value: 1,
          label: '链接'
        },
        {
          value: 2,
          label: '实物'
        }
      ],
      memberDayOptions: [
        {
          label: '星期一',
          value: '1'
        },
        {
          label: '星期二',
          value: '2'
        },
        {
          label: '星期三',
          value: '3'
        },
        {
          label: '星期四',
          value: '4'
        },
        {
          label: '星期五',
          value: '5'
        },
        {
          label: '星期六',
          value: '6'
        },
        {
          label: '星期日',
          value: '7'
        }
      ],
      classifyOptions: [
        {
          label: '请选择',
          value: ''
        },
        {
          label: '节日福利',
          value: 1
        },
        {
          label: '会员专属日',
          value: 2
        },
        {
          label: '生日福利',
          value: 3
        }
      ]
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  methods: {
    saveMemberInterestAction() {
      let id = this.$route.query.id
      this.formInline.in_grade_list = this.interestFitValue.toString()
      modifyMemberInterestDetails(id, this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/member-interest-setting')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 会员未点亮
    handleFilesSuccess(res, file) {
      this.formInline.in_fit_logo = res.data.path
    },
    // 会员权益图标
    handleAvatarSuccess(res, file) {
      this.formInline.in_logo = res.data.path
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M)
    },
    loadMemberLevelList() {
      getMemberLevelList().then(res => {
        this.interestFitOptions = res.data.data.list
      })
    },
    getData() {
      let id = this.$route.query.id
      getMemberInterestDetails(id).then(res => {
        this.formInline = res.data.data
        if (this.formInline.in_grade_list !== '') {
          for (let one of this.formInline.in_grade_list.split(',')) {
            this.interestFitValue.push(parseInt(one))
          }
        }
      })
    }
  },
  created() {
    this.getData()
    this.loadMemberLevelList()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.add-btn {
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 890px;
  margin: 0 auto;
}
.box-content-form {
  margin: 61px auto;
  text-align: center;
  padding-left: 135px;
}
.box-content-form .el-form-item {
  width: 300px;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.avatar-uploader  {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.upload_img{
    position: relative;
}
.upload_img:hover .modify_img{
    display: inline-block;
}
.modify_img{
    position: absolute;
    height: 100%;
    width: 100%;
    background: #000;
    opacity: 0.6;
    display: none;
    top: 0;
    left: 0;
    color: #fff;
    font-size: 18px;
    line-height: 178px;
}
.interest-image {
  display: inline-block;
  width: 178px;
  position: relative;
}
.opacity-div {
  /*padding: 0 auto;*/
  width: 178px;
  height: 178px;
}
.opacity-div1:hover .back-div {
  opacity: 1 !important;
}
.opacity-div:hover .back-div {
  opacity: 1 !important;
}
.back-div {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  height: 178px;
  width: 178px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  color: #fff;
  line-height: 120px;
}
.default-images {
  width: 120px;
}
.interest-uploader {
  width: 178px;
  height: auto;
}
</style>
